"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function EyeCrossed24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M22.94594,12 C21.5419068,16.6252107 17.148434,20 11.94594,20 C10.0829706,20 8.32374165,19.5672521 6.76837349,18.799303 L8.93615953,17.5255807 C9.88566195,17.8339516 10.8987171,18 11.94594,18 C15.9665149,18 19.4834564,15.5524436 20.8338407,12 C20.6820062,11.6005703 20.5027813,11.2151089 20.2985301,10.8455244 L22.0227735,9.83325254 C22.4045853,10.5155641 22.71552,11.2409432 22.94594,12 Z M11.94594,4 C14.7432095,4 17.3065924,4.97564567 19.2971603,6.59672116 L22.8534889,4.5062899 L23.8534889,6.2383407 L1,19.6706987 L9.97674166e-14,17.9386479 L3.20173679,16.0570127 C2.18165489,14.8873195 1.40441591,13.5103258 0.945940003,12 C2.34997325,7.37478931 6.74344603,4 11.94594,4 Z M11.94594,6 C7.92536512,6 4.40842365,8.44755638 3.05803931,12 C3.48940275,13.1347838 4.14184241,14.1568246 4.96115444,15.0223573 L8.11875586,13.1666784 C8.00638212,12.7975763 7.94594,12.4058466 7.94594,12 C7.94594,9.790861 9.736801,8 11.94594,8 L11.94594,8 L11.945,10.917 L17.4296292,7.69413331 C15.8717781,6.62205572 13.9728592,6 11.94594,6 Z", id: `eyecrossed24-${id0}` })),
        react_1.default.createElement("g", { id: "eye-crossed-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#eyecrossed24-${id0}` })),
            react_1.default.createElement("use", { id: "Combined-Shape", fill: "#000000", fillRule: "nonzero", xlinkHref: `#eyecrossed24-${id0}` })));
}
function EyeCrossed24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(EyeCrossed24Svg, Object.assign({}, svgProps)));
}
exports.default = EyeCrossed24;
//# sourceMappingURL=EyeCrossed24.js.map